import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useCurrentPromo } from '../../../utils/hooks/useCurrentPromo';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import SaleBanner from '../../../banners/SaleBanner';

import s from './UserGiftSaleBanner.scss';

export interface Props {
  className?: string;
  user?: PapiUser;
}

/** A version of the SaleBanner specifically gifting an author from the DeviationPage */
const UserGiftSaleBanner: React.FC<Props> = ({ className, user }) => {
  const currentUser = useCurrentUser();
  const currentPromo = useCurrentPromo('gift');
  const currentUserIsRecipient = currentUser.userId === user?.userId;
  const isRegularUser = user?.type === 'regular';
  if (currentUserIsRecipient || !isRegularUser || !currentPromo) {
    return null;
  }

  return (
    <SaleBanner
      className={classnames(s['root'], className)}
      giftRecipient={user?.username}
      endDate={currentPromo?.endDate}
      discountValuePercent={currentPromo?.discountValuePercent}
      referralType={ReferralType.PROMOTION_BANNER_CONTENT_PAGE}
    />
  );
};
UserGiftSaleBanner.displayName = 'UserGiftSaleBanner';

export default UserGiftSaleBanner;
